import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormattingFunctions } from '../..';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SbAgTableColDef } from '../sb-ag-table-coldef';

import { Column, GridApi, ICellRendererParams, RowNode } from 'ag-grid-community';

@Component({
    selector: 'sb-ag-details-renderer',
    styleUrls: ['./sb-ag-details-renderer.scss'],
    template: `
        <div *ngIf="values" class="ag-details-panel">
            <div *ngFor="let item of values" class="ag-details-field-wrapper">
                <div class="ag-details-label">{{ item.label }}</div>
                <div [ngClass]="item.cellClasses" class="ag-details-value">
                    {{ item.value }}
                </div>
            </div>
        </div>
    `
})
export class SbAgDetailsRenderer implements ICellRendererAngularComp {
    values: { label: string; value: string; cellClasses?: string[] }[];
    formattingFunctions: FormattingFunctions;
    constructor(
        dateFormatter: DatePipe,
        numberFormatter: DecimalPipe,
        percentageFormatter: PercentPipe,
        translateService: TranslateService
    ) {
        this.formattingFunctions = new FormattingFunctions(
            dateFormatter,
            numberFormatter,
            percentageFormatter,
            translateService
        );
    }
    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.values = this.getValueToDisplay(params);
    }

    // gets called whenever the cell refreshes
    refresh(params: ICellRendererParams) {
        this.values = this.getValueToDisplay(params);
        return false;
    }

    getValueToDisplay(params: ICellRendererParams) {
        const displayedColIds = params.columnApi
            .getAllDisplayedColumns()
            .map((c) => c.getColId());
        const hiddenCols = params.columnApi.getAllColumns().filter(
            (c) =>
                // Ignore columns with empty headers (such as group columns)
                displayedColIds.indexOf(c.getColId()) < 0 && c.getColDef().headerName
        );
        return hiddenCols.map((col) => this.getColData(col, params.api, params.node));
    }

    getColData(
        col: Column,
        api: GridApi,
        rowNode: RowNode
    ): { label: string; value: string; cellClasses?: string[] } {
        const coldef = col.getColDef();
        const value = api.getValue(col, rowNode);
        const formatterTypes = coldef.type;
        const label = coldef.headerName;

        if (formatterTypes) {
            return {
                cellClasses: this.formattingFunctions.getCellClassRulesFromCellTypes(
                    formatterTypes,
                    value
                ),
                value: this.formattingFunctions.getFormattedTextFromCellTypes(
                    <SbAgTableColDef>coldef,
                    formatterTypes,
                    value
                ),
                label
            };
        }

        return { value, label };
    }
}
